<template>
  <div class="trip-form">
    <van-field v-model="form.name" label="名稱" placeholder="例如：2026 Tokyo Summer Trip" required />
    <van-field v-model="form.description" label="描述" type="textarea" rows="2" placeholder="這趟旅行的簡介（選填）" />
    <van-field v-model="destinationInput" label="目的地" placeholder="輸入城市後按 Enter" @keyup.enter.native="addDestination">
      <template #button>
        <van-button size="mini" @click="addDestination">加入</van-button>
      </template>
    </van-field>
    <div class="chip-row" v-if="form.destinations.length">
      <span v-for="(d, i) in form.destinations" :key="d" class="tag-chip removable" @click="form.destinations.splice(i, 1)">
        {{ d }} ×
      </span>
    </div>

    <div class="field-row">
      <van-field v-model="form.startDate" label="開始日期" type="date" placeholder="YYYY-MM-DD" />
      <van-field v-model="form.endDate" label="結束日期" type="date" placeholder="YYYY-MM-DD" />
    </div>
    <p class="muted hint">隨心遊可以不填日期，開始記錄第一筆 Moment 時會自動視為「旅行中」。</p>

    <van-field label="結算幣別" required>
      <template #input>
        <select v-model="form.settlementCurrency" class="native-select">
          <option v-for="c in currencies" :key="c" :value="c">{{ c }}</option>
        </select>
      </template>
    </van-field>

    <van-field label="封面">
      <template #input>
        <div class="emoji-row">
          <button
            v-for="e in emojis" :key="e" type="button"
            class="emoji-btn" :class="{ active: form.coverEmoji === e }"
            @click="form.coverEmoji = e"
          >{{ e }}</button>
        </div>
      </template>
    </van-field>

    <van-field v-model="tagInput" label="標籤" placeholder="例如 #food，按 Enter 加入" @keyup.enter.native="addTag">
      <template #button>
        <van-button size="mini" @click="addTag">加入</van-button>
      </template>
    </van-field>
    <div class="chip-row" v-if="form.tags.length">
      <span v-for="(t, i) in form.tags" :key="t" class="tag-chip removable" @click="form.tags.splice(i, 1)">
        {{ t }} ×
      </span>
    </div>

    <div class="actions">
      <van-button block type="default" @click="$emit('cancel')">取消</van-button>
      <van-button block type="primary" :disabled="!form.name" @click="submit">
        {{ submitText }}
      </van-button>
    </div>
  </div>
</template>

<script>
const CURRENCIES = ['HKD', 'JPY', 'TWD', 'USD', 'CNY', 'EUR']
const EMOJIS = ['✈️', '🗼', '🏖️', '⛰️', '🏙️', '🎌', '🚄', '🌸']

export default {
  name: 'TripForm',
  props: {
    initial: { type: Object, default: null },
    submitText: { type: String, default: '建立 Trip' }
  },
  data () {
    return {
      currencies: CURRENCIES,
      emojis: EMOJIS,
      destinationInput: '',
      tagInput: '',
      form: this.initial
        ? { ...this.initial, destinations: [...this.initial.destinations], tags: [...this.initial.tags] }
        : {
            name: '',
            description: '',
            destinations: [],
            startDate: '',
            endDate: '',
            settlementCurrency: 'HKD',
            coverEmoji: '✈️',
            tags: []
          }
    }
  },
  methods: {
    addDestination () {
      const v = this.destinationInput.trim()
      if (v && !this.form.destinations.includes(v)) this.form.destinations.push(v)
      this.destinationInput = ''
    },
    addTag () {
      let v = this.tagInput.trim()
      if (!v) return
      if (!v.startsWith('#')) v = '#' + v
      if (!this.form.tags.includes(v)) this.form.tags.push(v)
      this.tagInput = ''
    },
    submit () {
      if (!this.form.name) return
      this.$emit('submit', { ...this.form })
    }
  }
}
</script>

<style scoped>
.trip-form {
  padding: 4px 0 16px;
}
.field-row {
  display: flex;
}
.field-row >>> .van-cell { flex: 1; }
.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 16px 12px;
}
.removable { cursor: pointer; }
.hint {
  padding: 4px 16px 8px;
}
.native-select {
  border: none;
  font-size: 14px;
  width: 100%;
  background: transparent;
  color: var(--color-text);
}
.emoji-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.emoji-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: #fff;
  font-size: 17px;
}
.emoji-btn.active {
  border-color: var(--color-primary);
  background: #fff2ea;
}
.actions {
  display: flex;
  gap: 10px;
  padding: 16px 16px 0;
}
</style>
